// model/handleDrop.ts
import type { EditorView } from '@tiptap/pm/view';
import type { Slice } from '@tiptap/pm/model';
// @ts-ignore
import { handleImageDrop } from 'novel/plugins';

import { UploadFn } from './imageUpload';

/**
 * Обработчик drop-событий:
 * 1. Если это внутренний drag-and-drop ProseMirror —
 *    возвращаем `false`, чтобы штатный d&d таблиц/блоков отработал сам.
 * 2. В остальных случаях обрабатываем картинки через handleImageDrop.
 */
export const createHandleDrop =
  (uploadFn: UploadFn) =>
  (
    view: EditorView,
    event: DragEvent,
    _slice: Slice,
    moved: boolean,
  ): boolean => {
    const { dataTransfer } = event;

    if (dataTransfer?.types?.includes('application/x-prosemirror-node')) {
      return false;
    }

    return handleImageDrop(view, event, moved, uploadFn);
  };
